module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('h4'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('p', [_vm._v("Registrations")])]), _vm._v(" "), _vm._l((_vm.analytics), function(x) {
    return _c('div', {
      staticClass: "dash"
    }, [_c('h3', [_vm._v(_vm._s(x.count))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.capitalizeFirstLetter(x.checkpoint)))])])
  })], 2), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6d525ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 1491
// module chunks = 1